export default __webpack_public_path__ + "static/media/aib.1f5bd901.png";